import { Box } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";

var JoveDialogContent = function JoveDialogContent(props) {
  var children = props.children,
      className = props.className;
  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col', className || 'py-5'),
    children: children
  });
};

export default JoveDialogContent;